/**
 * @description 基本小表格
 *
 * @props {Array[Column]} columns 表头
    Column {
      name: string,
      id: string,
      width?: string, "xxpx" // 默认值 "150px"
      textAlign?: string, // 可选值 "left", "right", "center"; 默认值："left"
    }
 * @props {Array[string]} datas 数据
 *
 */
<template>
  <div class="table-content">
    <!-- 头部 -->
    <div class="header">
      <div
        class="cell"
        v-for="column in columns"
        :key="column.name"
        :style="{ width: column.width }"
      >
        {{ column.name }}
      </div>
    </div>
    <!-- 主体 -->
    <div class="main">
      <div class="main-col" v-for="(data, index) in datas" :key="index">
        <div
          class="cell"
          v-for="(column, sign) in columns"
          :key="column.id"
          :style="{ width: columns[sign].width || '150px', textAlign: columns[sign].textAlign || 'left' }">
          <span :class="{abnormal: sign == 1 && !data.completeTarget}">{{ data[column.id] }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gj-base-table",
  data() {
    return {};
  },
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    datas: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped lang="scss">
.abnormal {
  color: #F56C6C !important;
}
.table-content {
  .header {
    display: flex;
    .cell {
      border-top: 1px solid #ccc;
      border-left: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      font-size: 14px;
      color: #666;
      // text-align: left;
      padding: 10px 20px;
      box-sizing: border-box;
      font-weight: 600;
      &:last-child {
        border-right: 1px solid #ccc;
      }
    }
  }
  .main {
    .main-col {
      display: flex;
      .cell {
        box-sizing: border-box;
        border-left: 1px solid #ccc;
        font-size: 12px;
        padding: 12px 20px;
        color: #666;
        &:last-child {
          border-right: 1px solid #ccc;
        }
      }
      &:last-child {
        .cell {
          border-bottom: 1px solid #ccc;
        }
      }
    }
  }
}
</style>